import React, { memo, useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { TypeOfAnimal, useGetInitialCategoriesQuery } from '@/redux/services/catalogApi'
// import CatalogCategory from './CatalogCategory'
import slidePrevArrow from '@/assets/img/full-product/slide-prev.svg'
import slideNextArrow from '@/assets/img/full-product/slide-next.svg'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { B2BCard } from '@/components/b2b/B2BToday'
import CatalogCategory from '@/components/catalog/CatalogCategory'
import { useParams, usePathname } from 'next/navigation'
import { useAppDispatch } from '@/redux/hooks'
import { setAnimalType, setCheckboxesCategory } from '@/redux/features/filterSlice'
import { setCurrentCatalogCategory } from '@/redux/features/catalogSlice'
// import { B2BCard } from '../b2b/B2BToday'

type Props = {
    list: TypeOfAnimal[] | any
    animalTypes?: TypeOfAnimal[]
    type?: string
}

export const Categories: React.FC<Props> = memo(function Categories({ list, animalTypes, type }) {
    const dispatch = useAppDispatch()
    const [translate, setTranslate] = useState(0)
    const [screenWidth, setScreenWidth] = useState(1200)
    const [marginDifference, setMarginDifference] = useState(0)
    const { currentCatalogCategory } = useSelector((state: RootState) => state.catalogv1)
    // const currentCatalogCategory = []
    const { data: categories } = useGetInitialCategoriesQuery()
    const [types, setTypes] = useState<any>(animalTypes)
    // const [types, setTypes] = useState(animalTypes ? animalTypes : list)
    const sliderRef = useRef<HTMLUListElement>(null)
    const [startX, setStartX] = useState(0)
    const [dragDirection, setDragDirection] = useState(null)
    const sortOrder = ['pticevodstvo', 'zhivotnovodstvo', 'svinovodstvo', 'drugie-zhivotnye']

    let [sortedTypes, setSortedTypes] = useState<any[]>([...types])

    useEffect(() => {
        types && types[0] && types[0]?.id && types?.sort
            ? setSortedTypes(
                  [...types]?.sort((a, b) => {
                      return sortOrder.indexOf(a.translit) - sortOrder.indexOf(b.translit)
                  })
              )
            : null
    }, [types])

    const params = useParams()

    const pathname = usePathname()

    useEffect(() => {
        const paramsAnimalType = params?.catalog?.[0]

        if (!paramsAnimalType || !categories) return

        const animalType = categories.find(c => c.translit === paramsAnimalType)

        if (!animalType) return

        dispatch(setAnimalType([animalType?.id]))
        dispatch(setCheckboxesCategory(animalType?.id))
        if (animalType?.animal_types_category?.length > 0 && !animalType?.oneCategory) {
            setTypes(animalType?.animal_types_category)
        }
        // dispatch(setCurrentCatalogCategory(animalType.animal_types_category))
    }, [params?.catalog, categories])

    useEffect(() => {
        const handleDragStart = (e: MouseEvent | TouchEvent) => {
            const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX
            setStartX(clientX)
        }

        const handleDragMove = (e: MouseEvent | TouchEvent) => {
            if (startX !== null) {
                e.preventDefault()
                const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX
                const offsetX = clientX - startX
                if (offsetX > 0) {
                    setDragDirection('right')
                } else if (offsetX < 0) {
                    setDragDirection('left')
                } else {
                    setDragDirection(null)
                }
            }
        }

        const handleDragEnd = () => {
            if (dragDirection === 'right') {
                slidePrev()
            } else if (dragDirection === 'left') {
                slideNext()
            }
            setStartX(null)
            setDragDirection(null)
        }

        if (sliderRef.current) {
            sliderRef.current.addEventListener('mousedown', handleDragStart)
            sliderRef.current.addEventListener('touchstart', handleDragStart)
            document.addEventListener('mousemove', handleDragMove)
            document.addEventListener('touchmove', handleDragMove)
            document.addEventListener('mouseup', handleDragEnd)
            document.addEventListener('touchend', handleDragEnd)
        }

        return () => {
            if (sliderRef.current) {
                sliderRef.current.removeEventListener('mousedown', handleDragStart)
                sliderRef.current.removeEventListener('touchstart', handleDragStart)
            }
            document.removeEventListener('mousemove', handleDragMove)
            document.removeEventListener('touchmove', handleDragMove)
            document.removeEventListener('mouseup', handleDragEnd)
            document.removeEventListener('touchend', handleDragEnd)
        }
    }, [startX, dragDirection])

    const desktop = screenWidth <= 1250
    const pretablet = screenWidth <= 1000
    const tablet = screenWidth <= 700
    const preMobile = screenWidth <= 510
    const mobile = screenWidth <= 480

    const slidePrev = () => {
        if (translate < 0) {
            setTranslate(translate + marginDifference)
        }
    }

    const slideNext = () => {
        if (translate > -marginDifference * (list?.length - changeVisibleSlides())) {
            setTranslate(translate - marginDifference)
        }
    }

    const changeVisibleSlides = () => {
        if (mobile) {
            return 1
        }
        if (preMobile) {
            return 2
        }
        if (tablet) {
            return 2
        }
        if (pretablet) {
            return 3
        }
        return 4
    }

    const isSlider = () => {
        if (list?.length === changeVisibleSlides() || list?.length < changeVisibleSlides()) {
            return false
        } else {
            return true
        }
    }

    useEffect(() => {
        if (animalTypes && !pathname.includes('catalog')) {
            setTypes(currentCatalogCategory)
        } else {
            return
        }
    }, [currentCatalogCategory, pathname])

    useEffect(() => {
        const updateScreenWidth = () => {
            setScreenWidth(window.innerWidth)
        }

        const defineMarginDifference = () => {
            if (pretablet) {
                setMarginDifference(230)
                return
            }

            if (desktop) {
                setMarginDifference(240)
                return
            }

            setMarginDifference(282)
        }

        changeVisibleSlides()
        updateScreenWidth()
        defineMarginDifference()

        window.addEventListener('resize', updateScreenWidth)

        return () => {
            window.removeEventListener('resize', updateScreenWidth)
        }
    }, [screenWidth])

    return (
        <nav className={`categories-slider__wrapper ${type === 'labs' ? 'labs' : ''}`}>
            <div
                onClick={slidePrev}
                style={translate < 0 ? { opacity: 1, zIndex: 2 } : { opacity: 0, zIndex: -1 }}
                className={`categories-slider__nav categories-slider__nav_prev`}
            >
                <Image
                    src={slidePrevArrow}
                    alt='slider-arrow'
                />
            </div>
            <div
                onClick={slideNext}
                style={
                    translate > -marginDifference * (list?.length - changeVisibleSlides())
                        ? { opacity: 1, zIndex: 2 }
                        : { opacity: 0, zIndex: -1 }
                }
                className={`categories-slider__nav categories-slider__nav_next ${isSlider() && 'slider-nav-hidden'}`}
            >
                <Image
                    src={slideNextArrow}
                    alt='slider-arrow'
                />
            </div>
            <ul
                draggable
                ref={sliderRef}
                style={{ transform: `translateX(${translate}px)` }}
                className={`categories-slider__list`}
            >
                {type === 'b2b'
                    ? types.map(item => (
                          <B2BCard
                              item={item}
                              classItem={'labs__features-card'}
                          />
                      ))
                    : types
                    ? sortedTypes
                        ? sortedTypes?.map((item, i) => {
                              return (
                                  <CatalogCategory
                                      type={type}
                                      sliderTranslate={range => setTranslate(range)}
                                      classItem={!animalTypes ? 'labs__features-card' : null}
                                      key={item.title}
                                      item={item}
                                  />
                              )
                          })
                        : types?.map((item, i) => {
                              return (
                                  <CatalogCategory
                                      type={type}
                                      sliderTranslate={range => setTranslate(range)}
                                      classItem={!animalTypes ? 'labs__features-card' : null}
                                      key={item.title}
                                      item={item}
                                  />
                              )
                          })
                    : null}
            </ul>
        </nav>
    )
})
